const skills = [
  'Своевременно давать обратную связь — не откладывать разговор до критической точки.',
  'Отделять факт от оценки — опираться на конкретные наблюдаемые действия и результаты.',
  'Говорить о поведении, а не личности — обсуждать что именно сделано, а не какой сотрудник.',
  'Формулировать ожидания — чётко описывать, какой результат и поведение требуются.',
  'Задавать вопросы и слушать ответы — выяснять причины ситуации, а не только констатировать проблему.',
  'Выяснять причины проблемы — понимать, что привело к ситуации, прежде чем предлагать решение.',
  'Не уходить от неприятной темы — вести разговор прямо, сохраняя уважение к сотруднику.',
  'Сохранять конструктивный тон — даже в сложном разговоре не переходить на эмоции и обвинения.',
  'Работать с эмоциональной реакцией сотрудника — распознавать защитные реакции и возвращать разговор в рабочее русло.',
  'Фиксировать договорённости — завершать разговор конкретным планом действий, а не общими обещаниями.',
  'Добиваться ответственности сотрудника — чтобы сотрудник принимал на себя обязательства по изменению.',
  'Проводить повторный контроль — проверять выполнение договорённостей в согласованные сроки.',
  'Завершать разговор конкретным планом действий — чтобы обе стороны понимали, что и когда должно измениться.',
];

export default function SkillsAfterTraining() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Что должен уметь руководитель после обучения
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Практические навыки, которые руководители осваивают и отрабатывают в ходе программы
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {skills.map((skill, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-3 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{skill}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Хороший сложный разговор заканчивается не просто пониманием, а конкретной договорённостью о дальнейшем поведении и результате.
          </p>
        </div>
      </div>
    </section>
  );
}